// extracted by mini-css-extract-plugin
export var carousel = "slideshow-module--carousel--ab616";
export var nav = "slideshow-module--nav--ff365";
export var root = "slideshow-module--root--106ea";
export var slide = "slideshow-module--slide--bdf79";